export default __webpack_public_path__ + "static/media/TwoFactorAuth.c9a494c5.png";